import React from "react";
import {Button, Modal, Section, Title} from "@allxsmith/bestax-bulma";

export default function CreateModal({
  open,
  setOpen,
  id,
}) {

  const onClose = () => {
    setOpen(false);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose}>
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title>Transaction Created</Title>
          <p>Transaction created with id: <b>{id}</b></p>
          <Button
              color={"info"}
              onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
